export default __webpack_public_path__ + "static/media/uxui.c488bcb5.png";